export { default as normalizeUrl } from './normalize-url';
